import { render, staticRenderFns } from "./UnitText.vue?vue&type=template&id=2ebbb5c6&scoped=true&"
import script from "./UnitText.vue?vue&type=script&lang=js&"
export * from "./UnitText.vue?vue&type=script&lang=js&"
import style0 from "./UnitText.vue?vue&type=style&index=0&id=2ebbb5c6&lang=scss&scoped=true&"
import style1 from "./UnitText.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebbb5c6",
  null
  
)

export default component.exports